module.exports = __webpack_public_path__ + "media/images/icons/outlined/usergroup-add-b245dfe109ea5f86739e023fa657e5f0.svg";